export default __webpack_public_path__ + "static/media/yellowPin.c10aa0f9.svg";